"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var l = require("lenovo");
function Tracking(tagName) {
    $(document).ajaxError(function (event, jqxhr, settings, thrownError) {
        l.DTM.Lmd.pusherrorinfTrack(tagName, "Ajax error:" + settings.url + "  " + thrownError);
    });
    window.onerror = function (msg, url, lineNo, columnNo, error) {
        var string = msg.toLowerCase();
        var substring = "script error";
        if (string.indexOf(substring) > -1) {
            l.DTM.Lmd.pusherrorinfTrack(tagName, 'Script Error: See Browser Console for Detail');
        }
        else {
            var message = [
                'Message: ' + msg,
                'URL: ' + url,
                'Line: ' + lineNo,
                'Column: ' + columnNo,
                'Error object: ' + JSON.stringify(error)
            ].join(' - ');
            l.DTM.Lmd.pusherrorinfTrack(tagName, message);
        }
    };
}
exports.default = Tracking;
